__turbopack_context__.v({
  "qty-input": "QuantitySelector-module-scss-module__L0V3Cq__qty-input",
});
